import React, { PropsWithChildren, useState } from "react";
import { Drawer } from "@mui/material";
import SlideUnsaved from "@common/components/SlideUnsaved";
import useRole from "../hooks/useRole";

export interface RoleDrawerProps {
  open: boolean;
  onClose: () => void;
}

const RoleDrawer = ({
  open,
  onClose,
  children,
}: PropsWithChildren<RoleDrawerProps>): React.JSX.Element => {
  const [showWarning, setShowWarning] = useState<boolean>(false);

  const { isModified, cancelChanges } = useRole();

  const handleCloseWithWarning = () => {
    if (isModified) {
      setShowWarning(true);
    } else {
      setShowWarning(false);
      onClose();
    }
  };

  return (
    <Drawer
      open={open}
      onClose={() => {
        handleCloseWithWarning();
      }}
      anchor="bottom"
      slotProps={{
        paper: { elevation: 0, sx: { height: "90%", overflowX: "hidden" } },
      }}
    >
      <SlideUnsaved
        direction={"down"}
        warning={showWarning}
        onClose={() => {
          setShowWarning(false);
          cancelChanges();
        }}
        onCancel={() => setShowWarning(false)}
      />
      {children}
    </Drawer>
  );
};

export default RoleDrawer;
